@import '../../../assets/styles/theme.scss';

.checkbox {
  margin-right: 4px;
  padding: 8px;
  border-radius: 4px;
  background-color: white;
  border: 1px solid $meta;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: $meta;
  cursor: pointer;
  transition: all 0.15s linear;
  &.checked {
    border: 1px solid $orange-500;
    color: $orange-500;
    &:hover {
      background-color: $orange-100;
    }
  }
  &:hover {
    background-color: $lightGray;
  }
  .label {
    margin-left: 6px;
  }
}
.circle {
  height: 8px;
  width: 8px;
  border-radius: 16px;
  border: 1px solid $meta;
}
.circleChecked {
  height: 8px;
  width: 8px;
  border-radius: 16px;
  background-color: $orange-500;
}
